var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent } from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import ProductConditionInfo from '@/components/Blue/ProductDetailPage/Modules/ProductConditionInfo.vue';
import { datalayerService, facebookTrackingService } from '@/services/tracking';
import { blueProductsApiClient, filterApiClient } from '@/services/api';
import OpenPopupButton from '@/components/PopUps/OpenPopupButton.vue';
export default defineComponent({
    name: 'filter-box',
    components: { OpenPopupButton, ProductConditionInfo },
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
    data() {
        return {
            filterCategories: [],
            userSelection: [],
            selectableInCurrentScope: new Map(),
        };
    },
    methods: Object.assign(Object.assign({}, mapMutations('blue', {
        replaceProduct: 'SET_CURRENT_PRODUCT',
    })), { attributeInCurrentProduct(attribute_name, attribute_value) {
            var _a;
            if (attribute_name === 'Zustand') {
                attribute_name = 'condition';
            }
            return `${(_a = this.currentProduct.attributes[attribute_name]) === null || _a === void 0 ? void 0 : _a.attribute_value}` === attribute_value;
        },
        attributeWithCurrentScopeSelectable(attribute_name, attribute_value) {
            const set = this.selectableInCurrentScope.get(attribute_name);
            if (set === undefined) {
                return false;
            }
            return set.includes(attribute_value);
        },
        selectAttribute(filterValue) {
            return __awaiter(this, void 0, void 0, function* () {
                this.userSelection.push(filterValue);
                blueProductsApiClient
                    .getProductByFilterSelection(this.currentProduct.modelId, this.userSelection)
                    .then((data) => {
                    this.replaceProduct(data.unified);
                    datalayerService.pushProductView(data.unified);
                    datalayerService.pushCategoryPath(data.unified.categoryPath);
                    datalayerService.pushCategoryPathBlue(data.unified.categoryPathBlue);
                    facebookTrackingService.trackProductShow(data.unified);
                    const link = data.unified.link;
                    const partial = link.slice(link.indexOf('.'));
                    const path = partial.slice(partial.indexOf('/'));
                    window.history.pushState({}, '', path);
                    this.selectableInCurrentScope = new Map();
                    data.remainingAvailableFilters.forEach((attribute) => {
                        var _a;
                        const alreadySet = (_a = this.selectableInCurrentScope.get(attribute.attribute_name)) !== null && _a !== void 0 ? _a : [];
                        alreadySet.push(attribute.attribute_value);
                        this.selectableInCurrentScope.set(attribute.attribute_name, alreadySet);
                    });
                    if (data.currentFilterSet !== this.userSelection) {
                        console.log('leider konnten nicht alle deine Filter berücksichtigt werden');
                        this.userSelection = data.currentFilterSet;
                    }
                });
            });
        } }),
    mounted() {
        if (!this.currentProduct.modelId) {
            return;
        }
        filterApiClient.getAttributesForModel(this.currentProduct.modelId).then((attributes) => {
            Object.entries(attributes).forEach(([name, attributeSet]) => {
                const values = [];
                Object.keys(attributeSet).forEach((key) => {
                    const data = {
                        attribute_name: attributeSet[key].attribute_name,
                        attribute_value: attributeSet[key].attribute_value,
                        defines_variant: attributeSet[key].defines_variant,
                        pretty: attributeSet[key].pretty,
                    };
                    values.push(data);
                });
                const valuesOnly = [];
                values.forEach((attribute) => {
                    valuesOnly.push(attribute.attribute_value);
                });
                this.selectableInCurrentScope.set(name, valuesOnly);
                this.filterCategories.push({
                    filterName: name,
                    filterValues: values,
                });
            });
        });
    },
});
